import { ICallFormSteps } from './interfaces';

export const SCHEDULE_YOUR_CALL_FORM = 'scheduleYourCallForm';

export const CALL_FORM_STEPS: ICallFormSteps = {
  YOUR_DETAILS: {
    title: 'Your Details',
    subtitle: () => 'All fields are required',
  },
  CALL_DETAILS: {
    title: 'Event Details',
    subtitle: () => 'All fields are required',
  },
  CALL_FORMAT: {
    title: 'Event Format',
    subtitle: () => {
      return (
        <div>
          All fields are required.
          <br />
          *Indicates additional charges may apply.
        </div>
      );
    },
  },
  ADD_ONS: {
    title: 'Event Add-Ons',
    subtitle: () => '*Indicates additional charges may apply.',
  },
};
